/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlResolutionRequestReason
 */
export interface ControlResolutionRequestReason {
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestReason
     */
    reason_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlResolutionRequestReason
     */
    description?: string;
}

/**
 * Check if a given object implements the ControlResolutionRequestReason interface.
 */
export function instanceOfControlResolutionRequestReason(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlResolutionRequestReasonFromJSON(json: any): ControlResolutionRequestReason {
    return ControlResolutionRequestReasonFromJSONTyped(json, false);
}

export function ControlResolutionRequestReasonFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolutionRequestReason {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reason_id': !exists(json, 'reason_id') ? undefined : json['reason_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function ControlResolutionRequestReasonToJSON(value?: ControlResolutionRequestReason | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reason_id': value.reason_id,
        'description': value.description,
    };
}

